import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
var ConcurrencyInfoClass;
function ConcurrencyInfo() {
  if (ConcurrencyInfoClass === VOID) {
    class $ {
      constructor(dispatcher, coroutineScope) {
        this.d66_1 = dispatcher;
        this.e66_1 = coroutineScope;
      }
      m3() {
        return Key_instance;
      }
    }
    protoOf($).c47 = get;
    protoOf($).d47 = fold;
    protoOf($).e47 = minusKey;
    protoOf($).t44 = plus;
    initMetadataForClass($, 'ConcurrencyInfo', VOID, VOID, [Element()]);
    ConcurrencyInfoClass = $;
  }
  return ConcurrencyInfoClass;
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  ConcurrencyInfo as ConcurrencyInfo3mmnli95yq2g0,
};
//endregion

//# sourceMappingURL=ConcurrencyInfo.mjs.map
